module.exports = __webpack_public_path__ + "static/media/velocity_red.ba5f68b6.png";